module.exports = __webpack_public_path__ + "img/2.eabdfc72.jpg";